module.exports = __webpack_public_path__ + "rosacea_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_2_after.jpg
// module id = 979
// module chunks = 0